module.exports = __webpack_public_path__ + "static/media/logo.fa2a6163.svg";